import { LoaderEvent } from "../events/LoaderEvent";
import { BaseLoader } from "./BaseLoader";

export class ScriptLoader extends BaseLoader
{
    private _script: HTMLScriptElement;

    constructor(src: string, cacheTimestamp?: string, prependURL?: string, id?: string)
    {
        super(src, cacheTimestamp, prependURL, id);
    }

    getData(): any {
        return this._script;
    }

    load()
    {
        if(this._state == BaseLoader.STATE_LOADING)
            return;
        else if(this._state == BaseLoader.STATE_LOADED)
        {
            var self = this;
            setTimeout(function()
            {
                self.onLoaded();
            }, 0);
            return;
        }

        this._lastProgress = 0;
        this._state = BaseLoader.STATE_LOADING;
        $("head")[0].appendChild(this._script);
    }

    stop()
    {
        if(this._state != BaseLoader.STATE_LOADING)
            return;

        this._state = BaseLoader.STATE_IDLE;
    }

    dispose() {
        // TODO: check what will happen if we dispose the loader before it
        // has completed, check this for every type of loader

        this._script.onload = null;
        this._script.onerror = null;
        $(this._script).remove();

        super.dispose();
    }

    protected getResponseType(): string
    {
        throw "This method is irrelevant for this type of loader.";
    }

    protected setUpRequest()
    {
        this._script = document.createElement("script");

        this._script.onload = this.onLoaded.bind(this);
        this._script.onerror = this.onError.bind(this);

        const prependURL = this._prependURL ? this._prependURL : "";

        this._script.src = prependURL + this._src + this._getParameters;
    }

    protected onLoaded(event?: any)
    {
        this._state = BaseLoader.STATE_LOADED;
        this.dispatchEvent(new LoaderEvent(LoaderEvent.PROGRESS,
            {progress: 1, progressChange: 1}));
        this.dispatchEvent(new LoaderEvent(LoaderEvent.COMPLETE));
    }

    protected onError(event: any)
    {
        this._state = BaseLoader.STATE_ERROR;
        this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
    }
}
